import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { dialogContent, dialogTitle, paperProps } from './AsanConfirmation.sx';
import AsanImza from './AsanImza';
import { AsanSignSession } from '../model/types';
import { useCsi } from 'app/providers/csi/hooks/useCsi';
import { FormCsiAction, useFormCsiAction } from 'app/providers/csi/hooks/useFormCsiAction';
import { CsiMode } from 'app/providers/csi/model/types';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  /** ASAN session from the sign response, usually `toAsanSession(response)`. */
  session: AsanSignSession;
  isRegistration?: boolean;
  title?: string;
  redirectUrl?: string;
  isClosedAsanModal?: boolean;
  handleRedirect?: (data?: any) => void;
  repeat_action?: string;
  task_reference?: string;
  /**
   * What to do when the signing response contains csi:
   * 'confirm' (default) → confirmation dialog first, 'direct' → rating form right away,
   * 'none' → nothing (the page handles CSI itself).
   */
  csi?: CsiMode | 'none';
  /**
   * Success modal buttons ('go-home' / 'close') instead of the default form-CSI action; for pages
   * that route the backend's answer themselves.
   */
  onSuccessAction?: FormCsiAction;
}
const AsanConfirmation = (props: Props) => {
  const {
    open,
    close,
    session,
    isRegistration = false,
    title,
    redirectUrl,
    isClosedAsanModal,
    handleRedirect,
    repeat_action,
    task_reference,
    csi = 'confirm',
    onSuccessAction,
  } = props;
  const { t } = useTranslation();
  const { handleResponse: handleCsiResponse } = useCsi();
  const formCsiAction = useFormCsiAction(session.pathUrl);

  const handleResponseHandled = (data?: any) => {
    if (csi !== 'none') handleCsiResponse(data, csi);
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={(event, reason) => {
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
          return;
        }
        close(false);
      }}
    >
      <DialogTitle sx={dialogTitle}>
        <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>
          {t('commonTerms.confirmAsanImza')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        <AsanImza
          isRegistration={isRegistration}
          btnSx={{ marginTop: '62px' }}
          asanModalType={'transfer'}
          verifyCode={session.verifyCode}
          close={close}
          timerTime={session.timerTime}
          pathUrl={session.pathUrl}
          businessKey={session.businessKey}
          title={title}
          redirectUrl={redirectUrl}
          isClosedAsanModal={isClosedAsanModal}
          handleRedirect={handleRedirect}
          repeat_action={repeat_action}
          task_reference={task_reference}
          onResponseHandled={handleResponseHandled}
          onSuccessAction={onSuccessAction ?? formCsiAction}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AsanConfirmation;
